import React from 'react';

import FieldApi from '../../../../models/FieldApi';

export const Control = ({ allProps, ControlProps, controlConfig, CustomControl, extraProps = {} }) => {
  if (CustomControl) {
    return <CustomControl {...allProps} {...ControlProps} />;
  }

  const ControlEl = FieldApi.getComponent(controlConfig, 'control');
  return <ControlEl {...ControlProps} {...(extraProps || {})} />;
};
